import type { IconData } from '@stacksjs/iconify-core'

export const realEstateBuilding1: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v3.04h1.53V1.52h19.81v1.52H1.53v12.2H0v3.04h1.53v-1.52h19.81v1.52H1.53v12.19H0V32h32v-1.53h-1.52V18.28h-7.62v-1.52h7.62v1.52H32v-3.04h-1.52V3.04h-7.62V1.52h7.62v1.52H32V0Zm6.1 30.47v-7.62h4.57v7.62Zm6.09 0v-9.14H4.58v9.14H3.05V19.81h18.29v10.66Zm16.77-10.66v10.66h-6.1V19.81ZM3.05 15.24V4.57h18.29v10.67ZM28.96 4.57v10.67h-6.1V4.57Z\"/><path fill=\"currentColor\" d=\"M13.72 21.33v7.62h6.09v-7.62Zm4.57 3.05h-1.52v1.52h-1.53v-3.05h3.05zM16.77 6.09h-3.05v7.62h6.09V6.09Zm1.52 3.05h-1.52v1.52h-1.53V7.62h3.05zM7.62 27.43h1.53V25.9H7.62zM4.58 6.09v7.62h6.09V6.09Zm4.57 3.05H7.62v1.52H6.1V7.62h3.05z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default realEstateBuilding1
